<script setup>

</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258
       24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z"
      fill="#1F9AFF"
    />
    <path
      d="M16.13 15.773C15.948 15.213 15.423 14.8 14.8 14.8H14.1V12.7C14.1
       12.5143 14.0263 12.3363 13.895 12.205C13.7637 12.0737 13.5857 12 13.4
        12H9.2V10.6H10.6C10.7857 10.6 10.9637 10.5263 11.095 10.395C11.2262
         10.2637 11.3 10.0857 11.3 9.9V8.5H12.7C13.0713 8.5 13.4274 8.3525
          13.6899 8.08995C13.9525 7.8274 14.1 7.4713 14.1 7.1V6.813C14.9375
           7.15066 15.6808 7.68623 16.2661 8.37388C16.8514 9.06154 17.2614
            9.88078 17.4609 10.7615C17.6605 11.6422 17.6436 12.5582 17.4118
             13.4309C17.18 14.3037 16.7402 15.1073 16.13 15.773ZM11.3 17.551C8.535
              17.208 6.4 14.856 6.4 12C6.4 11.566 6.456 11.146 6.547 10.747L9.9
               14.1V14.8C9.9 15.1713 10.0475 15.5274 10.3101 15.7899C10.5726
                16.0525 10.9287 16.2 11.3 16.2M12 5C11.0807 5 10.1705 5.18106
                 9.32122 5.53284C8.47194 5.88463 7.70026 6.40024 7.05025
                  7.05025C5.7375 8.36301 5 10.1435 5 12C5 13.8565 5.7375
                   15.637 7.05025 16.9497C7.70026 17.5998 8.47194 18.1154
                    9.32122 18.4672C10.1705 18.8189 11.0807 19 12 19C13.8565
                     19 15.637 18.2625 16.9497 16.9497C18.2625 15.637
                      19 13.8565 19 12C19 11.0807 18.8189 10.1705
                       18.4672 9.32122C18.1154 8.47194 17.5998 7.70026
                        16.9497 7.05025C16.2997 6.40024 15.5281 5.88463 14.6788
                         5.53284C13.8295 5.18106 12.9193 5 12 5Z"
      fill="white"
    />
  </svg>
</template>